angular.module('businessThread')
    .controller('BusinessThreadLinkController', function ($uibModalInstance, BusinessThread, BusinessThreadService, data) {
        this.threads = []
        this.recentThreads = []
        this.selectedThread = null
        this.linkedIds = data && data.linkedIds ? data.linkedIds : []
        this.resourceType = data && data.resourceType
        this.resourceId = data && data.resourceId
        this.search = ''
        this.activeOnly = true
        this.loading = false
        this.loadingRecent = false
        this.creating = false
        this.today = (() => {
            let date = new Date()
            let month = ('0' + (date.getMonth() + 1)).slice(-2)
            let day = ('0' + date.getDate()).slice(-2)
            return date.getFullYear() + '-' + month + '-' + day
        })()

        this.refreshThreads = () => {
            this.loading = true
            return BusinessThread.autocomplete({
                search: this.search,
                activeOnly: this.activeOnly
            }).$promise.then(items => {
                this.threads = items || []
                if (this.selectedThread && (!this.threads.some(item => item.id === this.selectedThread.id) || this.isLinked(this.selectedThread))) {
                    this.selectedThread = null
                }
                return this.threads
            }).finally(() => this.loading = false)
        }

        this.loadRecentThreads = () => {
            this.loadingRecent = true
            return BusinessThread.recentLinked().$promise.then(items => {
                this.recentThreads = this.filterRecentThreads(items)
            }).finally(() => this.loadingRecent = false)
        }

        this.clearSearch = () => {
            this.search = ''
            return this.refreshThreads()
        }
        this.isExpired = thread => thread && thread.activeTo && thread.activeTo < this.today
        this.isFuture = thread => thread && thread.activeFrom && thread.activeFrom > this.today
        this.isInactive = thread => this.isExpired(thread) || this.isFuture(thread)
        this.inactiveLabel = thread => this.isExpired(thread) ? 'Po terminie' : 'Jeszcze nieaktywny'
        this.isLinked = thread => thread && this.linkedIds.indexOf(thread.id) !== -1
        this.filterRecentThreads = threads => (threads || [])
            .filter(thread => thread && !this.isLinked(thread))
            .slice(0, 3)
        this.selectThread = thread => {
            if (!this.isLinked(thread)) {
                this.selectedThread = thread
            }
        }
        this.chooseRecentThread = thread => {
            if (thread && thread.id && !this.isLinked(thread)) {
                $uibModalInstance.close(thread)
            }
        }
        this.isSelected = thread => this.selectedThread && thread && this.selectedThread.id === thread.id
        this.cancel = () => $uibModalInstance.dismiss('cancel')
        this.confirm = () => {
            if (this.selectedThread && this.selectedThread.id && !this.isLinked(this.selectedThread)) {
                $uibModalInstance.close(this.selectedThread)
            }
        }
        this.createThread = () => {
            if (this.creating) {
                return
            }

            this.creating = true
            return BusinessThreadService.create({
                resourceType: this.resourceType,
                resourceId: this.resourceId
            }).then(thread => {
                if (thread && thread.id) {
                    $uibModalInstance.close(thread)
                }
            }).catch(angular.noop).finally(() => this.creating = false)
        }
        this.refreshThreads()
        this.loadRecentThreads()
    })
